import React from "react";

// Little one-cycle (well, two) waveform doodles, drawn as polylines so each
// shape's "buzziness" is visible alongside the audio. Shared by the Learn
// page and the practice player's lesson rounds.
const CYCLES = 2;
const WAVE_FNS = {
  sine: (x) => Math.sin(x * CYCLES * 2 * Math.PI),
  triangle: (x) => {
    const t = (x * CYCLES) % 1;
    return t < 0.5 ? 4 * t - 1 : 3 - 4 * t;
  },
  sawtooth: (x) => 2 * ((x * CYCLES) % 1) - 1,
  square: (x) => ((x * CYCLES) % 1 < 0.5 ? 1 : -1),
};

const wavePoints = (fn) => {
  const pts = [];
  for (let i = 0; i <= 120; i++) pts.push(`${i},${(20 - 14 * fn(i / 120)).toFixed(1)}`);
  return pts.join(" ");
};

const WaveShape = ({ waveform }) => (
  <svg viewBox="0 0 120 40" className="h-8 w-full text-primary" preserveAspectRatio="none" aria-hidden>
    <polyline
      points={wavePoints(WAVE_FNS[waveform] || WAVE_FNS.sine)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export default WaveShape;
